"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createMesh;
exports.updateMesh = updateMesh;
var _RGBELoader = require("three/examples/jsm/loaders/RGBELoader.js");
var _GLTFLoader = require("three/examples/jsm/loaders/GLTFLoader");
var THREE = _interopRequireWildcard(require("three"));
var _scene = _interopRequireDefault(require("./scene"));
var _gsap = _interopRequireDefault(require("gsap"));
var _City = _interopRequireDefault(require("./mesh/City"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var city;
function createMesh() {
  // 创建城市
  city = new _City.default(_scene.default);
}
function updateMesh(time) {
  // city.update(time);
}